import { LEGEND_ITEM_RADIUS } from '../utils';

export default function () {
  let _selection;

  function chart(selection) {
    selection.each(function (data) {
      _selection = selection;

      _selection.style('position', 'absolute')
        .style('pointer-events', 'none')
        .style('z-index', 1050)
        .style('background', 'white')
        .style('padding', '6px')
        .style('border', '1px solid black')
        .style('border-radius', '4px')
        .style('box-shadow', '2px 2px 4px rgba(0, 0, 0, 0.4)');

      _selection.append('p')
        .style('font-weight', 'bold')
        .style('font-size', '12px');

      _selection.append('div')
        .append('svg');

      chart.hide();
    });
  }

  function updatePosition(position) {
    const offset = 10;
    _selection.style('left', position.x + offset + 'px')
      .style('top', position.y + offset + 'px');
  }

  function updateContent(data, title) {
    _selection.select('p')
      .html(title);

    if (data.length === 0) {
      return;
    }

    const legend = _selection.select('svg')
      .attr('height', 16 * data.length)
      .attr('width', 80)
      .selectAll('g')
      .data(data);

    const legendEnter = legend.enter().append('g')
      .attr('transform', function (d, i) { return 'translate(0,' + i * 16 + ')'; });

    legendEnter.append('circle')
      .attr('cx', 10)
      .attr('cy', 9)
      .attr('r', LEGEND_ITEM_RADIUS)
      .attr('stroke', 'black')
      .attr('stroke-width', 1)
      .merge(legend.select('circle'))
      .attr('cx', 10)
      .attr('fill', function (d) { return d.key; });

    legendEnter.append('text')
      .attr('font-size', 12)
      .attr('y', 9.5)
      .attr('dy', '0.32em')
      .attr('fill', 'black')
      .attr('text-anchor', 'end')
      .merge(legend.select('text'))
      .attr('x', 65)
      .text(function (d) { return d.value; });
  }

  chart.show = function () {
    _selection.style('display', 'block');
    return chart;
  }

  chart.update = function (position, data, title) {
    updatePosition(position);
    updateContent(data, title);

    return chart;
  }

  chart.hide = function () {
    _selection.style('display', 'none');
    return chart;
  }
  return chart;
}



// WEBPACK FOOTER //
// ./src/charts/d3/d3-tooltip-legend.js